import RegexPatterns from "app/services/RegexPatterns";
import { translate } from "app/filters/i18nFilter";

export interface AssetNameValidationResult {
    isValid: boolean;
    errorMsg?: string;
}

const errorBuilder = () => {
    return (errorMsgKey: string) => {
        return {
            isValid: false,
            errorMsg: translate(errorMsgKey),
        };
    };
};

const isEmptyName = (name: string) => {
    return !name || name.length <= 0;
};

const isLongerThanMaxLength = (name: string, maxLength: number) => {
    return name.length > maxLength;
};

const hasInvalidCharacters = (name: string, removePipesAndDots = true) => {
    let nameToTest = name;
    if (removePipesAndDots) {
        nameToTest = name.replaceAll("|", "").replaceAll(".", "");
    }
    const isFormatValid = RegexPatterns.unicodeOrWhitespaceOnly(nameToTest);
    return !isFormatValid;
};

export const userAssetNameUtils = {
    hasInvalidCharacters,
    isLongerThanMaxLength,
    isEmptyName,
    errorBuilder,
};
